import { JsonFormsRendererRegistryEntry, rankWith, uiTypeIs } from '@jsonforms/core';
import controlRenderer from './DestinationIpControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(5, uiTypeIs('CustomDestinationIp')),
};
